import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { AlertComponent } from '../../../../../components';
import { APP_ROUTES } from '../../../../../constants/app-routes';
import { getUserByCognitoId } from '../../../../../core/users/action';

const LinkButton = styled(Button)`
  text-transform: none;
  padding: 0;
  min-width: 0;
  text-decoration: underline;

  &:hover {
    text-decoration: underline;
  }
`;

function EventAlert({ isApproved }) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.users);

  const onReload = () => {
    dispatch(getUserByCognitoId(user.cognito_id));
  };

  return (
    <AlertComponent
      title="Create Event"
      content={
        <>
          <p>To create events:</p>
          <ul>
            {!isApproved && (
              <li>
                Your venue is under review. We approve most venues within 2 business days and email
                you when you can create events. <LinkButton onClick={onReload}>Reload</LinkButton>{' '}
                to check for updates
              </li>
            )}
          </ul>
        </>
      }
      severity="warning"
    />
  );
}

EventAlert.propTypes = {
  isApproved: PropTypes.bool.isRequired,
};

export default EventAlert;
